<template>
  <app-base-main
      no-padding
      parentTable
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          @query="$gjNoticeQuery"
          @reset="$gjReset"
          :reset="false">
        <gj-select
            v-if="false"
            v-model="filter.state"
            placeholder="状态"
        ></gj-select>
        <gj-search-input
            v-model="filter.keyword"
            width="180px"
            placeholder="类别/ASIN"
        ></gj-search-input>
        <gj-date-picker
            v-model="filter.date"
            type="daterange"
            tooltip="数据时间"
            :clearable="false"
            :max-day-length="180"
        ></gj-date-picker>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-checkbox
          v-model="filter.filterAdZero"
          @input="$gjNoticeQuery">
        <span style="color: #666">过滤广告业绩为0的数据</span>
      </gj-checkbox>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :index="false"
          name="asinAdProductTargetAnalysis"
          :data="tableData"
          :columns="columns"
          show-summary
          :loading="loading"
          :pagination="pagination"
          :default-sort="defaultSort"
          :offsetHeight="6"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:productTargetName="{row}">
          <template v-if="row.resolvedExpressionList && row.resolvedExpressionList.length > 0">
            <gj-tooltip
                v-for="(item, i) in row.resolvedExpressionList"
                :key="i"
                :content="`${item.type}=${item.value}`"
                :text-line="1">
              <template v-if="item.type === 'asinSameAs'">
                asinSameAs=<gj-link :href="row.asinAmazonUrl" target="_blank">{{item.value}}</gj-link>
              </template>
              <template v-else-if="item.type === 'exactProduct'">商品浏览</template>
              <template v-else-if="item.type === 'similarProduct'">类似商品浏览</template>
              <template v-else-if="isMeaningful(item.type) && isMeaningful(item.value)">
                {{item.type}}={{item.value}}
              </template>
              <template v-else>-</template>
            </gj-tooltip>
          </template>
          <template v-else>-</template>
        </template>
        <template v-slot:campaignName="{row}">
          <div v-gutter="4">
            <app-ad-route-link
                    :market-id="marketId"
                    :type="AdTypeEnum.SP"
                    :campaign="row">
              {{row.campaignName}}
            </app-ad-route-link>
            <span>&gt;</span>
            <app-ad-route-link
                    :market-id="marketId"
                    :type="AdTypeEnum.SP"
                    :campaign="row"
                    :group="row"
                    :group-targeting-type="AdGroupEnum.SP.targetingType.KEYWORD">
              {{row.groupName}}
            </app-ad-route-link>
          </div>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {AdCampaignEnum, AdKeywordEnum, AdGroupEnum} from "../../../common/enum";
  import {adFields} from "../../../common/fields";
  import {isMeaningfulMixin, queryMixin} from "../../../../../../minxins";
  import {adDefaultSortMixin, adTypeRouteMixin, currencySymbolMixin} from "../../../common/mixin";
  import {getAdsAsinPerformanceTargeting} from "../../../../../../api/ad";
  import {isMeaningful} from "../../../../../../utils/common";
  import {convertToDate} from "../../../../../../utils/date.util";
  import AppAdRouteLink from "../../../common/components/app-ad-route-link";

  export default {
    name: "app-asin-product-target-analysis",
    components: {AppAdRouteLink},
    mixins: [queryMixin, adTypeRouteMixin, currencySymbolMixin, isMeaningfulMixin, adDefaultSortMixin],
    props: {
      marketId: {
        required: true,
      },
      currencySymbol: {
        required: true,
      },
      item: {
        required: true
      },
      queryDate: {
        required: true
      }
    },
    created() {
      this.filter.date = this.queryDate;
      /*this.sort.prop = 'impressions';*/
    },
    data() {
      return {
        tableData: [],
        columns: [
          adFields.picture,
          {...adFields.productTargetName, field: 'targetingText'},
          adFields.ctr,
          adFields.cost,
          adFields.cpc,
          adFields.cvr,
          adFields.acos,
          adFields.impressions,
          adFields.clicks,
          adFields.orders,
          // adFields.orderProductSales,
          adFields.cpa,
          // adFields.suggestBid,
          adFields.bid,
          {...adFields.campaignName, fixed: null, minWidth: '250px'},
          {
            ...adFields.servingStatus,
            width: '100px',
            options: [...AdCampaignEnum.SP.servingStatusOption, ...AdCampaignEnum.SB.servingStatusOption],
            defaultShow: '广告活动已暂停'
          }
        ],
        filter: {
          state: null,
          keyword: null,
          date: null,
          filterAdZero: false
        },
        AdKeywordEnum: AdKeywordEnum,
        AdGroupEnum: AdGroupEnum
      }
    },
    methods: {
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            marketId: this.marketId,
            targetingText: this.filter.keyword,
            msku: this.item.msku,
            startDate: convertToDate(this.filter.date[0]),
            endDate: convertToDate(this.filter.date[1]),
          },
          ...this.queryPagination,
          ...this.querySortEx
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getAdsAsinPerformanceTargeting(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = this.currencySymbolMixin(data.records, this.currencySymbol);
              this.pagination = this.getPagination(data);
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          })
      },
    }
  }
</script>

<style lang="scss" scoped>
/deep/ .gj-table .gj-help--icon .gj-icon{
  color: #999999;
}
</style>
